import { Button, Col } from "antd";
import { ReactNode } from "react";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { enmVoucherTypes, IDamageCaseVoucher, IDamageCaseVoucherProps, IDamageCaseVoucherStates } from "../interfaces";
import { DamageCaseVoucherPaymentItem } from "./damageCaseVoucherPaymentItem";

export class DamageCaseVoucherPayment extends EntityManager<IDamageCaseVoucher, IDamageCaseVoucherProps, IDamageCaseVoucherStates>{
    static initMetadata = (): IMetadata => {
        return {
            title: "حواله",
            name: "DamageCaseVoucherPayment",
            Properties: [
                {
                    title: "شماره حواله",
                    dataIndex: "VoucherNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: true
                },
                {
                    title: "وضعیت",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        options: [{ title: "آماده پرداخت", value: 0 }, { title: "پرداخت شده", value: 1 }]
                    }
                },
                {
                    title: "تاریخ صدور",
                    dataIndex: "IssueDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    filterable: true
                },
                {
                    title: "شماره چک",
                    dataIndex: "ChequeNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: true
                },
                {
                    title: "تاریخ چک",
                    dataIndex: "ChequeDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    filterable: true
                }
            ]
        };
    }
    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.originalFilter = () => {
            return ComparisonFilter.Equal<IDamageCaseVoucher>(v => v.Type, enmVoucherTypes.Payment);
        };

        this.renderingToolbar = () => {
            let result: ReactNode[] = [];
            let damageCaseVoucherPaymentItemAccess = this.initialData?.AccessList["DamageCaseVoucherPaymentItem"];

            if (damageCaseVoucherPaymentItemAccess === true) {
                result.push(
                    <Col key="DamageCaseVoucherPaymentItems" style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={this.onVoucherItemsClick}>اقلام حواله</Button>
                    </Col>
                );
            }

            return result.length ? (<> {result} </>) : (<></>);
        };
    }
    onVoucherItemsClick = () => {
        this.addLookupForm("DamageCaseVoucherPaymentItem",
            <DamageCaseVoucherPaymentItem
                key="DamageCaseVoucherPaymentItem"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { voucher: this.selectedEntity! };
                }}
            />);
    }
}